<template>
  <availability>
    <div class="availability-holiday">
      <div class="title">Set your holiday</div>
      <div class="month">
        <i class="material-icons month-back" @click="previousMonth"
          >arrow_back</i
        >
        <span v-text="selectedMonth"></span>
        <i class="material-icons month-forward" @click="nextMonth"
          >arrow_forward</i
        >
      </div>
      <div class="weeks">
        <div class="week">MON</div>
        <div class="week">TUE</div>
        <div class="week">WED</div>
        <div class="week">THU</div>
        <div class="week">FRI</div>
        <div class="week">SAT</div>
        <div class="week">SUN</div>
      </div>
      <div class="days">
        <div
          class="days-item"
          v-for="(day, index) in startDays"
          :key="index"
          :class="{
            selected:
              selectedHoliday.indexOf(
                currentDate.getFullYear() +
                  '-' +
                  (currentDate.getMonth() + 1) +
                  '-' +
                  day
              ) >= 0
                ? true
                : false
          }"
          @click="setting(day)"
        >
          <span v-if="convertDate(day)">{{ day === 0 ? '' : day }}</span>
          <span class="non-active" v-else>{{ day === 0 ? '' : day }}</span>
        </div>
      </div>
    </div>
  </availability>
</template>

<script>
import Availability from './Availability'
import { setHoliday, getHoliday } from '../../api/availability'

export default {
  name: 'availability-holiday',
  components: { Availability },
  data() {
    return {
      tempTitle: '',
      tempBoxTitle: '',
      tempIndex: null,
      currentDate: new Date(),
      startDate: '',
      selectedMonth: '',
      startDays: [],
      monthToCharacters: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],
      nowDate: new Date(),
      startIndex: '',
      selectedHoliday: []
    }
  },
  created() {
    this.tempBoxTitle = this.boxTitle
    this.selectedMonth =
      this.monthToCharacters[this.currentDate.getMonth()] +
      ' ' +
      this.currentDate.getFullYear()
    this.tempTitle = this.title
    this.changeMonth()
  },
  mounted() {
    if (this.startIndex !== '') {
      const indexDate = this.startIndex.split('-')
      const year = parseInt(indexDate[2], 10)
      const month = parseInt(indexDate[1], 10) - 1
      const day = parseInt(indexDate[0], 10)
      this.currentDate = new Date(year, month, day)
      this.setCalendarTitle()
      this.setting(day)
    } else {
      this.startDate = this.currentDate
    }

    getHoliday(this.$store.getters.userInfo.uid).then(doc => {
      this.selectedHoliday.push(...doc)
    })
  },
  methods: {
    convertDate(day) {
      const compareDate = new Date(this.currentDate).setDate(day)
      if (this.nowDate.getTime() > compareDate) {
        return false
      } else {
        return true
      }
    },
    setting(day) {
      if (day > 0) {
        this.tempIndex = day
        const date =
          this.currentDate.getFullYear() +
          '-' +
          (this.currentDate.getMonth() + 1) +
          '-' +
          day
        this.tempTitle = day + ' ' + this.selectedMonth
        const index = this.selectedHoliday.indexOf(date)
        if (index >= 0) {
          console.log('pop')
          this.selectedHoliday.splice(index, 1)
        } else {
          console.log('push')
          this.selectedHoliday.push(date)
        }
        setHoliday(this.selectedHoliday, this.$store.getters.userInfo.uid)
      }
    },
    changeMonth() {
      const tempStartDate = new Date(this.currentDate.getTime())
      this.startDays = []
      tempStartDate.setDate(1)
      if (tempStartDate.getDay() === 0) {
        this.startDays = new Array(6)
        this.startDays.push(1)
      } else {
        this.startDays = new Array(tempStartDate.getDay() - 1)
        this.startDays.push(1)
      }
      for (let i = 2; i < 32; i++) {
        tempStartDate.setDate(i)
        if (this.currentDate.getMonth() === tempStartDate.getMonth()) {
          this.startDays.push(tempStartDate.getDate())
        }
      }
    },
    previousMonth() {
      this.currentDate.setMonth(this.currentDate.getMonth() - 1)
      this.setCalendarTitle()
    },
    nextMonth() {
      this.currentDate.setMonth(this.currentDate.getMonth() + 1)
      this.setCalendarTitle()
    },
    setCalendarTitle() {
      this.selectedMonth =
        this.monthToCharacters[this.currentDate.getMonth()] +
        ' ' +
        this.currentDate.getFullYear()
      this.changeMonth()
    }
  }
}
</script>

<style lang="scss" scoped>
.availability-holiday {
  width: 1080px;
  position: relative;
  left: 0;
  right: 0;
  margin: auto auto 80px auto;
  font-family: Poppins;

  .month-back {
    margin: 0 20px 0 0;
    cursor: pointer;
  }

  .month-forward {
    margin: 0 0 0 20px;
    cursor: pointer;
  }

  .title {
    font-size: 17px;
    font-weight: 300;
    letter-spacing: 1px;
    margin: 40px 0 12px;
  }

  .month {
    height: 70px;
    background-color: #ffffff;
    border-top: solid 1px #e7e7e7;
    border-left: solid 1px #e7e7e7;
    border-right: solid 1px #e7e7e7;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .month span {
    font-family: Poppins;
    font-size: 20px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #000000;
  }

  .weeks {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-gap: 1px;
    grid-auto-rows: minmax(60px, 50px);

    .week {
      font-family: Poppins;
      font-size: 16px;
      font-weight: 200;
      letter-spacing: 1px;
      color: #000000;
      text-align: center;
      line-height: 60px;
    }
  }

  .days {
    width: 100%;
    display: grid;
    justify-content: space-between;
    grid-template-columns: repeat(auto-fill, 153.2px);
    /*background-color: #eee;*/

    .days-item {
      cursor: pointer;
      width: 153.2px;
      height: 90px;
      display: flex;
      border-bottom: 1px solid #fff;
      user-select: none;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-weight: 300;
      position: relative;

      &::before {
        content: '';
        display: flex;
        /*border: 1px solid #fff;*/
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }

      &.day {
        background-color: #f5f5f5;
        cursor: pointer;
      }

      &.selected {
        font-weight: 600;
        color: #fff;
        background-color: #0fb564;
      }

      .non-active {
        cursor: not-allowed;
        width: 153.2px;
        height: 90px;
        display: flex;
        /*border-left: 1px solid #fff;*/
        /*border-top: 1px solid #fff;*/
        user-select: none;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        font-weight: 300;
        background-color: #eee;
        color: #a9a9a9;
        position: relative;
        &::before {
          content: '';
          display: flex;
          border-top: 1px solid #fff;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
        }
      }
    }
  }

  .day-text-wrap {
    display: table;
    width: 100%;
    margin: 60px 0 0;

    .day-text {
      width: 1080px;
      height: 92px;
      background-color: #ffffff;
      border: solid 1px #e7e7e7;
      font-family: Poppins;
      vertical-align: middle;
      padding: 0 20px;
      position: relative;
      margin: 20px 0 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &:first-child {
        margin: 0;
      }

      span {
        font-size: 21px;
        font-weight: 800;
        color: #000;
      }

      button {
        width: 150px;
        height: 50px;
        font-size: 15px;
        font-weight: 300;
        color: #000;
        border: 1px solid #ddd;
        outline: none;
        border-radius: 2px;
        background: none;
        letter-spacing: 1px;
      }
    }

    .time-text button,
    .buttons button {
      width: 150px;
      height: 50px;
      font-size: 15px;
      font-weight: 300;
      color: #000;
      border: 1px solid #ddd;
      outline: none;
      border-radius: 2px;
      background: none;
      letter-spacing: 1px;
    }
  }
}
</style>
